import { render, staticRenderFns } from "./PaperBidView.vue?vue&type=template&id=49a6f182"
import script from "./PaperBidView.vue?vue&type=script&lang=js"
export * from "./PaperBidView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports